import * as React from 'react';
import * as Yup from 'yup';

import Box from '@appbuckets/react-ui/Box';
import buildMutationFormAction from '../_lib/buildMutationFormAction';
import HookedInput from '@appbuckets/react-ui-forms/HookedInput';


// ----
// Internal Props
// ----
interface ForgotPasswordProps {
  onSuccess?: () => void;
}

interface ForgotPasswordDto {
  email: string;
}


/* --------
 * Schema Definition
 * -------- */
const forgotPasswordSchema: Yup.SchemaOf<ForgotPasswordDto> = (
  Yup.object({
    email: Yup.string().email('Email Invalido').required('Email è obbligatoria')
  })
);


/* --------
 * Action Definition
 * -------- */
const ForgotPasswordAction = buildMutationFormAction<ForgotPasswordDto, ForgotPasswordProps, any>({
  displayName: 'ForgotPasswordAction',

  schema: forgotPasswordSchema,

  defaultProps: () => ({
    modal: true,
    modalProps: {
      header: 'Recupera Password'
    },
    submitButton: 'Invia',
    cancelButton: 'Annulla'
  }),


  // ----
  // Action Render
  // ----
  Content: () => (
    <React.Fragment>
      <Box mb={4}>
        <p>
          Inserisci il tuo indirizzo email per ricevere le istruzioni per reimpostare la password.
        </p>
      </Box>

      <HookedInput
        name={'email'}
        label={'Indirizzo Email'}
        type={'email'}
        required
        autoComplete={'email'}
      />
    </React.Fragment>
  ),

  invalidateQueries: [],

  onMutate: async (data, client) => {
    return client.request({
      method: 'POST',
      url: 'auth/request-password-reset',
      withAccessToken: false,
      withRefreshToken: false,
      data: {
        email: data.email
      }
    });
  },


  toast: {
    onCreatingSubmit: 'Istruzioni per il recupero password inviate alla tua email!',
    onError: 'thrown'
  }

});

ForgotPasswordAction.displayName = 'ForgotPasswordAction';

export default ForgotPasswordAction;
